import { Button, VbzInputText } from '@smiles/voebiz-ui-kit';
import { SendMilesIcon, SearchIcon } from 'components';
import { Dropdown, DropdownOptions } from 'components/Dropdown';
import IncludeManyPeople from 'components/Icons/IncludeManyPeople';
import IncludeOnePerson from 'components/Icons/IncludeOnePerson';
import ModalInclude from 'components/ModalInclude';
import { useTransactions } from 'contexts/Transactions';
import { useExportCsv } from 'contexts/ExportCsv';
import debounce from 'lodash/debounce';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { stringSearch } from 'utils/stringSearch';

const TableSearch = () => {
  const { exportCsv } = useExportCsv();

  const [searchParams, setParams] = useSearchParams();

  const paramsModal = searchParams.get('m');

  const { isEmpty, setFilter, filter, getListTransactions, rewardCustomersIsEnabled } = useTransactions();

  const navigate = useNavigate();

  const { t } = useTranslation('beneficiaries');

  const [openFilterModal, setOpenFilterModal] = useState(false);

  const [typeInclude, setTypeInclude] = useState('one');

  const [modalType, setModalType] = useState<'team' | 'clients' | 'default'>('team');

  const [openDropdownInclude, setOpenDropdownInclude] = useState(false);

  const [openDropdownMoreActions, setOpenDropdownMoreActions] = useState(false);

  const [openModalInclude, setOpenModalInclude] = useState(false);

  const isFilterModalClosed = !openFilterModal;

  const handleFilterChange = debounce((key?: string) => {
    const search = stringSearch(key);

    setFilter({ search });
  }, 400);

  const handleCleanFilter = () => {
    setFilter({ search: undefined });
  };

  const handleOpenDropdownInclude = () => {
    setOpenDropdownInclude(true);
  };

  const handleOpenModalInclude = (type: 'team' | 'clients' | 'one' | 'many') => {
    setOpenDropdownInclude(false);
    setOpenModalInclude(true);
    if (rewardCustomersIsEnabled) {
      if (type === 'team' || type === 'clients') {
        setModalType(type);
      }
    } else {
      setTypeInclude(type);
      setModalType('default');
    }
  };

  const handleCloseModalInclude = () => {
    setOpenModalInclude(false);
    getListTransactions();
  };

  useEffect(() => {
    document.body.classList.remove('unscrollable');
  }, [isFilterModalClosed]);

  const optionsInclude = useMemo<DropdownOptions[]>(
    () => [
      {
        onClick: () => handleOpenModalInclude(rewardCustomersIsEnabled ? 'team' : 'one'),
        label: rewardCustomersIsEnabled ? t('include_team') : t('include_one'),
        icon: <IncludeOnePerson />,
      },
      {
        onClick: () => handleOpenModalInclude(rewardCustomersIsEnabled ? 'clients' : 'many'),
        label: rewardCustomersIsEnabled ? t('include_clients') : t('include_many'),
        icon: <IncludeManyPeople />,
      },
    ],
    [t, rewardCustomersIsEnabled],
  );

  useEffect(() => {
    if (paramsModal === 'dropdown-modal-include') {
      setOpenModalInclude(true);
      setTypeInclude('many');
      setParams('');
    }
  }, [paramsModal, setParams]);

  return (
    <div className="w-100 container-table-header">
      <div className="w-100 search-input-container">
        <VbzInputText
          className="input-search search-campaign"
          value={filter?.search}
          onChange={({ target }) => handleFilterChange(target.value)}
          placeholder={t('search')}
          disabled={isEmpty}
          icon={
            <>
              {filter?.search && (
                <button
                  type="button"
                  className="icon-clear"
                  data-testid="button-clear-search"
                  onClick={() => handleCleanFilter()}
                >
                  <i className="material-icons">close</i>
                </button>
              )}
              <SearchIcon />
            </>
          }
        />
      </div>
      <div className="action-groups-container">
        <div className="w-100 button-filter-container container-btn-common" />
        <div className="w-100 button-include-team-container container-btn-common beneficiaries-dropdown">
          <Button
            className="button-include-team btn-common-actions btn-common-actions-orange"
            icon={<SendMilesIcon />}
            onClick={handleOpenDropdownInclude}
          >
            {t('include_team_text')}
          </Button>
          <Dropdown
            close={() => setOpenDropdownInclude(false)}
            open={openDropdownInclude}
            options={optionsInclude}
            id="dropdown-modal-include"
          />
        </div>
      </div>

      <ModalInclude
        isOpen={openModalInclude}
        closeModal={handleCloseModalInclude}
        setTab={setTypeInclude}
        type={typeInclude}
        modalType={modalType}
      />
    </div>
  );
};

export default TableSearch;
